import React, { memo, useState } from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import dimensions from "../../globalStyles/dimensions";
import GlobalStyles from "../../globalStyles/globalStyles";

import CancelModal from "./CancelModal";
import DateModal from "../ExperienceModals/DateModal";
import ExperienceIcons from "../../assets/Icons/ExperienceIcons";
import ModalComponent from "../ModalComponent";

const CancelConfirmationModal = ({
  visible,
  toggleModal,
}: {
  visible: any;
  toggleModal: any;
}) => {
  const [finallyCancel, setFinallyCancel] = useState(false);
  const [reschedule, setReschedule] = useState(false);

  const data = [
    // { id: 1, name: 'Food', desc: 'Food from a luxury hotel in Thailand' },
    { id: 2, name: "Drinks", desc: "Drinks from a luxury hotel in Thailand" },
  ];

  const handleFinallyCancel = () => {
    setFinallyCancel(!finallyCancel);
  };

  const handleReschedule = () => {
    setReschedule(!reschedule);
  };

  return (
    <>
      <CancelModal visible={finallyCancel} toggleModal={handleFinallyCancel} />
      <DateModal isVisible={reschedule} toggleModal={handleReschedule} />
      <ModalComponent isVisible={visible} toggleModal={toggleModal}>
        <View style={styles.container}>
          <View style={styles.subContainer}>
            <View style={styles.header}>
              <Text style={[GlobalStyles.heading3]}>
                Are you sure you want to cancel your booking?
              </Text>
              <Pressable onPress={toggleModal}>
                <ExperienceIcons.Cross />
              </Pressable>
            </View>
          </View>

          <View style={[styles.buttonContainerView]}>
            <View
              style={[
                styles.buttonView,
                { backgroundColor: "#FDFBF9", borderBottomLeftRadius: 10 },
              ]}
            >
              <Pressable onPress={handleFinallyCancel}>
                <Text style={[GlobalStyles.bodyText, styles.okGotItText]}>
                  Cancel booking
                </Text>
              </Pressable>
            </View>
            <View
              style={[
                styles.buttonView,
                { backgroundColor: "#1F3930", borderBottomRightRadius: 10 },
              ]}
            >
              <Pressable onPress={handleReschedule}>
                <Text style={[GlobalStyles.bodyTextBold, { color: "#FDFBF9" }]}>
                  Reschedule
                </Text>
              </Pressable>
            </View>
          </View>
        </View>
      </ModalComponent>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    // paddingHorizontal: dimensions.paddingHorizontal,
    // paddingVertical: dimensions.paddingVertical / 2,
    backgroundColor: "white",
    width: dimensions.windowWidth / 1.1,
    top: 20 * 20,
    // top:dimensions.windowHeight,
    borderRadius: 10,
    height: 179,
  },
  subContainer: {
    paddingHorizontal: dimensions.paddingHorizontal,
    paddingVertical: dimensions.paddingVertical,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: dimensions.marginVertical,
  },
  content: {
    flex: 1,
  },
  itemContainer: {
    marginBottom: dimensions.marginVertical,
  },
  itemName: {
    marginBottom: dimensions.marginVertical,
  },
  itemDesc: {
    color: "gray",
  },
  okGotItView: {
    backgroundColor: "#1F3930",
    // position:'relative',
    // bottom:0,
    width: "100%",
    height: 50,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  },
  okGotItText: {
    // alignSelf:'center'
    // color:'#FDFBF9'
  },
  buttonContainerView: {
    flexDirection: "row",
  },
  buttonView: {
    // backgroundColor:'red',
    width: "50%",
    height: 60,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
});

export default memo(CancelConfirmationModal);
